exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-img[data-v-2da7456a]{position:relative;top:-200px;width:100%}.breakdown[data-v-2da7456a],.next[data-v-2da7456a]{margin-top:40px;width:100%}.adj[data-v-2da7456a]{margin-bottom:0;margin-top:.7em;color:#ee752f}hr[data-v-2da7456a]{margin-top:.5em}.num[data-v-2da7456a],.top[data-v-2da7456a]{display:flex;align-items:center}.num[data-v-2da7456a]{border:2px solid #000;border-radius:500px;margin-right:20px;width:50px;height:50px;justify-content:center}.num>[data-v-2da7456a]{margin:0}table[data-v-2da7456a]{margin:30px 0}table>tr[data-v-2da7456a]{vertical-align:top;color:#6d6d6d}.first-col[data-v-2da7456a]{width:20%;margin-right:20px;padding:0}pre[data-v-2da7456a]{width:100%;display:flex;justify-content:center}.next-proj[data-v-2da7456a],.prev-proj[data-v-2da7456a]{width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2da7456a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/flashfood-counter.vue
// module id = 347
// module chunks = 0